const RECIPIENT_RELATIONSHIP_OPTIONS = [
  { value: 'destinatario', key: 'destinatario' },
  { value: 'familiar', key: 'familiar' },
  { value: 'conjuge', key: 'conjuge' },
  { value: 'amigo', key: 'amigo' },
  { value: 'vizinho', key: 'vizinho' },
  { value: 'porteiro', key: 'porteiro' },
  { value: 'colega', key: 'colega' },
  { value: 'responsavel', key: 'responsavel' },
  { value: 'outro', key: 'outro' },
];

Object.freeze(RECIPIENT_RELATIONSHIP_OPTIONS);

const ORDER_TYPE_PICKUP_AT_WARECLOUD = 11;

const RECIPIENT_NAME_MAX_LENGTH = 45;
const RECIPIENT_DOCUMENT_MAX_LENGTH = 50;
const VALID_RECIPIENT_NAME_REGEX_PATTERN = /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑüÜ]+$/;
const VALID_RECIPIENT_DOCUMENT_REGEX_PATTERN = /^[A-Za-z0-9.-]+$/;

export {
  ORDER_TYPE_PICKUP_AT_WARECLOUD,
  RECIPIENT_RELATIONSHIP_OPTIONS,
  RECIPIENT_NAME_MAX_LENGTH,
  RECIPIENT_DOCUMENT_MAX_LENGTH,
  VALID_RECIPIENT_NAME_REGEX_PATTERN,
  VALID_RECIPIENT_DOCUMENT_REGEX_PATTERN,
};
